<div class="alert has-body is-warning">
    <span class="icon">
        <i class="tri-alert" aria-hidden="true"></i>
    </span>
    <div class="body">
        <p class="title is-level-6">{{ title }}</p>
        <div [innerHTML]="description" class="mt-1"></div>
        @if (showCompatibilityLink) {
            <p class="text is-level-2 mt-1">
                <a
                    class="link"
                    (click)="onCompatibilityLinkClick()"
                    checkoutCy="esim_compatibiliy_modal_link">
                    Voir les appareils compatibles eSIM
                </a>
            </p>
        }
    </div>
</div>
